export const NumericFilterOperations = ['=', '<>', '<', '>', '<=', '>='];
